import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/category/rpg', label: '角色扮演' },
    { to: '/category/simulation', label: '模拟经营' },
    { to: '/category/visual-novel', label: '视觉小说' },
    { to: '/category/mobile', label: '手机黄油' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-gamepad-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                黄游免费下载
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              海量黄游免费下载资源，涵盖各类热门黄游，安全快速，持续更新，为您提供最优质的游戏下载体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">游戏分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 rounded-full text-xs bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 黄游免费下载 - 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <Link to="/about" className="hover:text-background-300 transition-colors cursor-pointer">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}